import script from "./EditGroupChatModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditGroupChatModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__